import api from "./api";

const metricsService = {
  getDashboardMetrics: async (params?: any) => {
    try {
      const response = await api.get("/dashboard", { params });
      console.log("Dashboard metrics raw response:", response);
      return response;
    } catch (error) {
      console.error("Dashboard metrics API error:", error);
      throw error;
    }
  },

  getHistoricalData: async (params?: any) => {
    try {
      const response = await api.get("/historical-data", { params });
      console.log("Historical data raw response:", response);
      return response;
    } catch (error) {
      console.error("Historical data API error:", error);
      throw error;
    }
  },

  getRealTimeMetrics: async () => {
    try {
      const response = await api.get("/real-time");
      console.log("Real-time metrics raw response:", response);
      return response;
    } catch (error) {
      console.error("Real-time metrics API error:", error);
      throw error;
    }
  },

  getPerformanceReport: async (params?: any) => {
    try {
      const response = await api.get("/performance-report", { params });
      return response.data;
    } catch (error) {
      console.error("Performance report API error:", error);
      throw error;
    }
  },
};

export default metricsService;
